// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {baseUrl} from './utils/config.js'

import './css/381.css'
import "./css/886.css";
import "./css/919.css";
import "./css/app.css";

import axios from 'axios'
Vue.prototype.$http=axios
 
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.baseUrl = baseUrl
Vue.use(ElementUI);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js